module.exports = __webpack_public_path__ + "static/media/hh_logo.52f0a19c.svg";